import { CommonGetOptions } from "interfaces/dataInterfaces"
import { householdApi } from "./householdApi"

export const subCategoriesApi = householdApi.injectEndpoints({
  endpoints: builder => ({
    getSubCategories: builder.query<CommonGetOptions[], { categoryId: number }>({
      query: ({ categoryId }) => ({
        url: `SurveySubCategories/Get`,
        method: "GET",
        params: { categoryId },
      }),
      providesTags: ["SubCategories"],
    }),

    addSubCategory: builder.mutation<void, { name: string; categoryId: number }>({
      query: ({ name, categoryId }) => ({
        url: `SurveySubCategories/Add`,
        method: "POST",
        params: { name, categoryId },
      }),
      invalidatesTags: ["SubCategories"],
    }),

    editSubCategory: builder.mutation<void, { id: number; name: string; categoryId: number }>({
      query: ({ id, name, categoryId }) => ({
        url: `SurveySubCategories/Put/${id}`,
        method: "PUT",
        params: { name, categoryId },
      }),
      invalidatesTags: ["SubCategories"],
    }),

    deleteSubCategory: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `SurveySubCategories/Delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["SubCategories"],
    }),
  }),
})

export const {
  useGetSubCategoriesQuery,
  useLazyGetSubCategoriesQuery,
  useAddSubCategoryMutation,
  useEditSubCategoryMutation,
  useDeleteSubCategoryMutation,
} = subCategoriesApi
